import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllQuizzes } from '../data/quizRegistry';

interface QuizRecommendationsProps {
  currentQuizId: string;
}

const QuizRecommendations: React.FC<QuizRecommendationsProps> = ({ currentQuizId }) => {
  const navigate = useNavigate();
  const quizzes = getAllQuizzes().filter((q) => q.id !== currentQuizId);

  if (quizzes.length === 0) return null;

  return (
    <div style={{ width: '100%', maxWidth: '500px', margin: '20px 0' }}>
      <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '12px' }}>
        🧪 다른 테스트도 해보세요!
      </p>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
        {quizzes.map((quiz) => (
          <div
            key={quiz.id}
            onClick={() => navigate(`/quiz/${quiz.id}`)}
            style={{
              background: `linear-gradient(135deg, ${quiz.gradient[0]}, ${quiz.gradient[1]})`,
              borderRadius: '16px',
              padding: '20px',
              width: '140px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'transform 0.2s',
            }}
          >
            <div style={{ fontSize: '32px', marginBottom: '8px' }}>{quiz.icon}</div>
            <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#333' }}>{quiz.shortTitle}</div>
            <div style={{ fontSize: '11px', color: '#555', marginTop: '6px' }}>테스트하기 →</div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default QuizRecommendations;
